import NpsList from "./NpsList";

function RelatoriosNps() {
    return (
        <NpsList />
    )
}

export default RelatoriosNps;